import React, { useEffect, useRef } from 'react';
export function Hero() {
  const sectionRef = useRef<HTMLElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current && imageRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          imageRef.current.style.transform = `translateY(${rect.top * 0.15}px)`;
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative min-h-[88vh] md:min-h-screen overflow-hidden bg-espresso" data-id="element-107">
      {/* Background image with parallax */}
      <div ref={imageRef} className="absolute -inset-y-[15%] inset-x-0 transition-transform duration-100 will-change-transform" data-id="element-108">
        <img src="https://cdn.magicpatterns.com/uploads/d9W3N6pCLwQA5vyBbYaXzP/PILATES_Sweater_Girl_2.png" alt="Pure Pulse Pilates sweatshirt editorial" className="w-full h-full object-cover object-right" data-id="element-109" />
      </div>

      {/* Mobile: full dark scrim so centered text is readable. Desktop: left-side gradient. */}
      <div className="absolute inset-0 md:hidden" style={{
      backgroundImage: 'linear-gradient(to bottom, rgba(43,36,32,0.55) 0%, rgba(43,36,32,0.65) 50%, rgba(43,36,32,0.75) 100%)'
    }} data-id="element-110" />
      <div className="absolute inset-0 hidden md:block" style={{
      backgroundImage: 'linear-gradient(to right, rgba(43,36,32,0.85) 0%, rgba(43,36,32,0.5) 35%, rgba(43,36,32,0.1) 60%, rgba(43,36,32,0) 75%)'
    }} data-id="element-111" />

      {/* Content */}
      <div className="relative min-h-[88vh] md:min-h-screen max-w-7xl mx-auto px-5 sm:px-6 md:px-10 lg:px-16 flex flex-col justify-center py-20 md:py-24" data-id="element-112">
        <div className="mx-auto md:mx-0 text-center md:text-left max-w-md md:max-w-md lg:max-w-xl" data-id="element-113">
          {/* Eyebrow */}
          <div className="flex items-center justify-center md:justify-start gap-3 md:gap-4 text-cream/80 mb-5 md:mb-8" data-id="element-114">
            <span className="h-px w-6 md:w-10 bg-rust" data-id="element-115" />
            <span className="text-[10px] md:text-xs uppercase tracking-widest" data-id="element-116">
              For the girls who Pilates
            </span>
            <span className="h-px w-6 bg-rust md:hidden" data-id="element-117" />
          </div>

          {/* Headline */}
          <h1 className="font-serif font-light text-cream text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight mb-5 md:mb-8" data-id="element-118">
            Pilates girls
            <br data-id="element-119" />
            <em className="not-italic" data-id="element-120">do it</em>{' '}
            <span className="text-rust italic" data-id="element-121">better.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-cream/85 text-sm md:text-lg leading-relaxed mb-7 md:mb-10 mx-auto md:mx-0 max-w-md" data-id="element-122">
            Elevated activewear designed to sculpt, support, and move with you.
            Refined essentials for the Pilates girl, from the reformer to real
            life.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start" data-id="element-123">
            <a href="https://shop.purepulsepilates.com" className="bg-cream text-espresso px-8 py-4 rounded-full uppercase tracking-widest text-xs hover:bg-rust hover:text-cream transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-124">
              Shop New In
            </a>
            <a href="https://shop.purepulsepilates.com" className="border border-cream/70 text-cream px-8 py-4 rounded-full uppercase tracking-widest text-xs hover:bg-cream hover:text-espresso transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-125">
              Shop Bestsellers
            </a>
          </div>
        </div>

        {/* Bottom meta row */}
        <div className="hidden md:flex absolute bottom-10 left-10 right-10 lg:left-16 lg:right-16 items-end justify-between text-cream/60 text-xs uppercase tracking-widest pointer-events-none" data-id="element-126">
          <span data-id="element-127">New Season / 2026</span>
          <span className="flex items-center gap-2" data-id="element-128">
            Scroll
            <span className="h-px w-8 bg-cream/50" data-id="element-129" />
          </span>
        </div>
      </div>
    </section>;
}